import React, { useEffect } from 'react';
import { View, Text, Image, Platform, TouchableOpacity } from 'react-native-web';
import { isIOS, isMobile } from 'react-device-detect';

// APIs
import { getCityList } from '../../modules/api_cities';
import { clearAllUserData, getCuisineList, getUserData } from '../../modules';

// Assets
import { ReactComponent as GooglePlay } from '../../images/svg_playStore.svg';
import { ReactComponent as AppStore } from '../../images/svg_appStore.svg';

// Utils
import { getData, showAppError } from '../../utils/util_helpers';
import { updateAccountList, updateLocationList } from '../../utils/util_main_app';

// Root Navigation
import * as RootNavigation from '../../navigation/RootNavigation';
import routeKeys from '../../navigation/RouteKeys';

// Configs
import GLOBAL from '../../configs/config_global';
import DATA from '../../configs/config_data';

export function Blank() {
    useEffect(() => {
        if (!isMobile) {
            mainFunc();
        }
    }, []);

    const mainFunc = () => {
        Promise.all([
            getData('currentToken'),
            getData('accountListIndex'),
            getData('currentLocation'),
            getCuisineList().catch(() => Promise.resolve(null)),
            getCityList().catch(() => Promise.resolve([]))
        ])
            .then((localDataArr) => {
                const savedTokenObj = localDataArr[0] ? JSON.parse(localDataArr[0]) : null;
                const savedAccountListIndex = localDataArr[1] ? JSON.parse(localDataArr[1]).index : 0;
                const squareLocationObj = localDataArr[2] ? JSON.parse(localDataArr[2]) : null;

                // Set cuisine list
                GLOBAL.CUISINE_LIST = localDataArr[3]?.data || DATA.cuisines;

                // Load welcome screen
                if (savedTokenObj) {
                    console.log('[SPLASH] SAVED ACCOUNT DATA', savedTokenObj);

                    // Check if local is storing a list of multiple accounts or just one
                    // (For legacy support)
                    let accountList = Array.isArray(savedTokenObj) ? savedTokenObj : [savedTokenObj],
                        usingAccount = null,
                        usingAccountIndex = savedAccountListIndex;

                    console.log('[SPLASH] SAVED ACCOUNT LIST', accountList);
                    console.log('[SPLASH] SAVED ACCOUNT INDEX', savedAccountListIndex);

                    // Check if last used account is not expired yet, if yes use this account
                    if ((usingAccountIndex > -1) && !accountList[usingAccountIndex].isExpired) {
                        usingAccount = accountList[usingAccountIndex];
                    }
                    else {
                        usingAccount = accountList[0];
                    }

                    // Check if there's any valid account (token not expired yet)
                    if (!usingAccount) {
                        // Notify users that all accounts are expired
                        GLOBAL.MAIN?.toast.show('Your login session has expired, please log in again', 2000);

                        // Clear global user data
                        clearAllUserData();

                        // Complete loading state and go to login screen
                        RootNavigation.reset(routeKeys.WELCOME);

                        return;
                    }

                    // Update main account list
                    updateAccountList(accountList, usingAccountIndex);

                    // Get user data
                    getUserData(usingAccount.token, usingAccount.service || 'email')
                        .then((userData) => {
                            // Check current selected location
                            const locationList = userData['locations'];

                            // Get Square location list
                            if (squareLocationObj) {
                                console.log('[SPLASH] SAVED SQUARE LOCATION', squareLocationObj);
                                let locationIndex = locationList.findIndex((item) => item['squareup_location_id'] === squareLocationObj['squareup_location_id']);
                                updateLocationList(locationIndex > -1 ? locationIndex : 0, locationList);
                                RootNavigation.reset(routeKeys.MAIN);
                            }
                            else {
                                updateLocationList(0, locationList);
                                RootNavigation.reset(routeKeys.MAIN);
                            }
                        })
                        .catch((userDataError) => {
                            clearAllUserData();
                            RootNavigation.reset(routeKeys.WELCOME);
                            showAppError(userDataError);
                        });
                }
                else {
                    console.log('[SPLASH] NOT FOUND TOKEN');
                    RootNavigation.reset(routeKeys.WELCOME);
                }
            });
    }

    const logoWidth = 180;
    return(
        <View style={{ width: '100%', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            {/* Logo */}
            <Image
                source={require('../../images/logo_vendor_portrait.png')}
                style={{ width: logoWidth, height: (71 / 111) * logoWidth, marginTop: 64, opacity: 0.5 }}
            />

            {/* Loading Text */}
            {
                isMobile ?
                    <View style={{ alignSelf: 'stretch', alignItems: 'center' }}>
                        <Text style={{ color: 'gray', fontWeight: '500', fontSize: 16, lineHeight: 24, textAlign: 'center', marginVertical: 48, marginHorizontal: 56 }}>
                            Looks like you are using a mobile device, please download the Truckster Vendor app for the best experience
                        </Text>

                        {/* App Store Button */}
                        <TouchableOpacity
                            onPress={() => window.open(isIOS ? 'itms-apps://itunes.apple.com/app/id1375287755' : 'https://play.google.com/store/apps/details?id=com.truckster', '_blank') }
                            style={{ alignItems: 'center' }}>
                            {
                                isIOS ?
                                    <AppStore height={128} width={400} />
                                    :
                                    <GooglePlay height={64} width={200} />
                            }
                        </TouchableOpacity>
                    </View>
                    :
                    <Text style={{ color: 'gray', fontSize: 20, fontWeight: 'bold', marginTop: 24 }}>
                        Loading...
                    </Text>
            }
        </View>
    );
}
